import files from "./files";

export default {
    files,
};
